import React, { useEffect, useState } from "react";
import NavBar from "../../components/navBar/NavBar";
import "./home.css";
import {
  collection,
  query,
  getDocs,
  deleteDoc,
  doc,
  where,
  orderBy
} from "firebase/firestore";
import { auth, db } from "../../utitilties/firebase";
import HomeItem from "./components/HomeItem";
import HomeSearch from "./components/HomeSearch";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const isSuperAdmin = auth?.currentUser?.email == "admin@orebro.com";

  const navigate = useNavigate();

  const [datas, setDatas] = useState([]);
  const [filteredArray, setFilteredArray] = useState([]);
  const [user, setUser] = useState();
  const getPhysioCenters = async () => {
    const q = query(collection(db, "PhysioCenters"), orderBy("centerCode"));

    const querySnapshot = await getDocs(q);

    let list = [];
    querySnapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });

    list.sort((a, b) => a.invitationCode - b.invitationCode);

    let therapists = await getAllPhysioTherapists();
    let clients = await getAllClients();

    list.forEach((center) => {
      center.therapists = [];
      center.clients = 0;

      therapists.forEach((t) => {
        if (center.id == t.centerId) {
          t.clients = [];
          center.therapists.push(t);
          clients.forEach((cl) => {
            if (cl.invitationCode == t.invitationCode) {
              center.clients = center.clients + 1;
              t.clients.push(cl);
            }
          });
        }
      });
    });

    setDatas(list);
    setFilteredArray(list);
  };

  const getAllPhysioTherapists = async () => {
    const q = query(collection(db, "PhysioTherapists"));

    const querySnapshot = await getDocs(q);

    let list = [];
    querySnapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });

    return list;
  };

  const getAllClients = async () => {
    const q = query(collection(db, "Users"));

    const querySnapshot = await getDocs(q);

    let list = [];
    querySnapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });

    return list;
  };

  const getUser = async () => {
    const q = query(
      collection(db, "PhysioCenters"),
      where("email", "==", auth.currentUser.email)
    );

    const querySnapshot = await getDocs(q);
    let tempUser = "";
    querySnapshot.forEach((doc) => {
      tempUser = { id: doc.id, ...doc.data() };
    });

    setUser(tempUser);

    await getTherapists(tempUser);
  };

  const getTherapists = async (user) => {
    const q = query(
      collection(db, "PhysioTherapists"),
      where("centerId", "==", user.id)
    );

    const querySnapshot = await getDocs(q);
    let tempCenters = [];
    querySnapshot.forEach((doc) => {
      tempCenters.push({ id: doc.id, ...doc.data() });
    });

    tempCenters.sort((a, b) => a.invitationCode - b.invitationCode);

    const invitationCodes = await getNoOfInvitationCodes();
    tempCenters.forEach((center, idx) => {
      tempCenters[idx].noOfclients =
        invitationCodes[center.invitationCode] ?? 0;
    });

    setDatas(tempCenters);
    setFilteredArray(tempCenters);
  };

  const getNoOfInvitationCodes = async () => {
    // this will return how many times an invittion code is used.
    // thus can get no of clients for each therapisths
    const clients = await getAllClients();
    const countMap = {};

    clients.forEach((obj) => {
      const code = obj.invitationCode;
      if (countMap[code]) {
        countMap[code]++;
      } else {
        countMap[code] = 1;
      }
    });
    return countMap;
  };

  const deleteHandler = async (id) => {
    let confirm = window.confirm("Are you sure want to delete?");
    if (confirm) {
      await deleteDoc(
        doc(db, isSuperAdmin ? "PhysioCenters" : "PhysioTherapists", id)
      );

      if (isSuperAdmin) {
        getPhysioCenters();
      } else {
        getUser();
      }
    }
  };

  useEffect(() => {
    if (!auth?.currentUser?.email) {
      navigate("/login");
    }

    if (isSuperAdmin) {
      getPhysioCenters();
    } else {
      getUser();
    }
  }, []);
  console.log(user, "uuuu");
  return (
    <>
      <NavBar />
      <div
        style={{
          padding:10,
          display: "flex",
          alignItems: "center",
          // justifyContent: "center",
          // backgroundColor:"red"
        }}
      >
        <div style={{display:'flex ',flexDirection:'column',alignItems:'center'}} >
          <img
            src={user?.logo}
            alt="logo"
            style={{
              width: 150,
              height: 150
            }}
          />
          <p>{user?.name}</p>
        </div>
        <div className="home">
          <HomeSearch
            filteredArray={filteredArray}
            setFilteredArray={setFilteredArray}
            array={datas}
          />
          <div
            className="home_item"
            style={{ marginTop: 20, backgroundColor: "gray", color: "white" }}
          >
            <p style={{ width: 250 }}>
              {isSuperAdmin ? "Center Name" : "Therapist Name"}
            </p>
            <p style={{ width: 250 }}>Email</p>
            <p style={{ width: 50 }}>Code</p>

            {isSuperAdmin && (
              <>
                <p style={{ width: 150, textAlign: "center" }}>
                  Physiotherapists
                </p>
                <p style={{ width: 80, textAlign: "center" }}>Clients</p>
              </>
            )}
            {!isSuperAdmin && (
              <p style={{ width: 50, textAlign: "center" }}>No. Of Clients</p>
            )}
            {!isSuperAdmin && (
              <p style={{ marginLeft: 25 }} className="ico">
                Share
              </p>
            )}

            <p style={{ marginLeft: 25 }} className="ico">
              Edit
            </p>
            <p className="ico">Del</p>
          </div>
          {filteredArray.map((center) => (
            <HomeItem
              deleteHandler={deleteHandler}
              center={center}
              from={"HOME"}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Home;
